import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useMemberAuth } from "../auth/MemberAuthContext";

export function MemberRequireAuth() {
  const { session, isLoading } = useMemberAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#003580] text-sm text-white">
        Checking your session…
      </div>
    );
  }

  if (!session) {
    return (
      <Navigate
        to="/member/login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  return <Outlet />;
}
